module.exports = __webpack_public_path__ + "static/media/Circle-whitea.f2e2d955.svg";